import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/writeOff',
    children: [
      {
        path: '',
        name: 'writeOff',
        meta: {
          title: '注销账号',
        },
        component: () => import('@/views/writeOff/index.vue'),
      },
      {
        path: 'agreement',
        name: 'writeOffAgreement',
        meta: {
          title: '注销账号协议',
        },
        component: () => import('@/views/writeOff/agreement.vue'),
      },
      {
        path: 'authentication',
        name: 'writeOffAuthentication',
        meta: {
          title: '身份验证',
          auth: true,
        },
        component: () => import('@/views/writeOff/authentication.vue'),
      },
      {
        path: 'reason',
        name: 'writeOffReason',
        meta: {
          title: '注销账号',
          auth: true,
        },
        component: () => import('@/views/writeOff/reason.vue'),
      },
    ],
  },
]

export default routes
